import React, { useState, useEffect } from 'react';
import { X, Share, Plus, Smartphone } from 'lucide-react';
import { Button } from '../components/ui/button';

export const IOSInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    const isInStandaloneMode = () => 
      ('standalone' in window.navigator) && (window.navigator.standalone);

    // Afficher le prompt si iOS et pas en mode standalone
    if (isIos() && !isInStandaloneMode()) {
      const hasSeenPrompt = localStorage.getItem('ios-install-prompt-seen');
      if (!hasSeenPrompt) {
        setTimeout(() => setShowPrompt(true), 3000);
      }
    }
  }, []);

  const handleClose = () => {
    setShowPrompt(false);
    localStorage.setItem('ios-install-prompt-seen', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end">
      <div className="bg-white rounded-t-2xl p-6 w-full animate-slide-up">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center">
              <Smartphone size={24} className="text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Installer Bytransport</h3>
              <p className="text-sm text-slate-600">Accédez rapidement depuis votre écran d'accueil</p>
            </div>
          </div>
          <button onClick={handleClose} className="p-2">
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-blue-600 font-semibold text-sm">1</span>
            </div>
            <div>
              <p className="text-sm font-medium">Appuyez sur le bouton de partage</p>
              <div className="flex items-center gap-2 mt-2 p-2 bg-slate-50 rounded-lg">
                <Share size={20} className="text-blue-500" />
                <span className="text-xs text-slate-600">En bas de Safari</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-blue-600 font-semibold text-sm">2</span>
            </div>
            <div>
              <p className="text-sm font-medium">Sélectionnez "Sur l'écran d'accueil"</p>
              <div className="flex items-center gap-2 mt-2 p-2 bg-slate-50 rounded-lg">
                <Plus size={20} className="text-blue-500" />
                <span className="text-xs text-slate-600">Dans le menu de partage</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-blue-600 font-semibold text-sm">3</span>
            </div>
            <div>
              <p className="text-sm font-medium">Confirmez l'installation</p>
              <p className="text-xs text-slate-600 mt-1">L'icône Bytransport apparaîtra sur votre écran</p>
            </div>
          </div>
        </div>

        <Button onClick={handleClose} className="w-full">
          J'ai compris
        </Button>
      </div>
    </div>
  );
};
